import { useState } from "react";

interface CampoBuscaProps {
  placeholder?: string;
  aoBuscar?: (valor: string) => void;
  isSidebarOpen?: boolean; // Recebe apenas esta prop
}

const CampoBusca = ({
  placeholder = "Buscar aplicativo",
  aoBuscar,
  isSidebarOpen,
}: CampoBuscaProps) => {
  const [valorBusca, setValorBusca] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const valor = event.target.value;
    setValorBusca(valor);
    if (aoBuscar) aoBuscar(valor);
  };

  const limparBusca = () => {
    setValorBusca("");
    if (aoBuscar) aoBuscar("");
  };

  return isSidebarOpen ? (
    <div className="flex items-center border rounded-md w-full">
      <input
        type="text"
        className="flex-1 px-3 py-1 rounded-md focus:outline-none outline-none"
        placeholder={placeholder}
        value={valorBusca}
        onChange={handleChange}
      />
      {valorBusca && (
        <button
          onClick={limparBusca}
          className="px-3 py-1 text-gray-500 hover:text-gray-800 focus:outline-none"
        >
          &#x2715;
        </button>
      )}
    </div>
  ) : (
    <div className="flex items-center justify-center h-9 w-9 bg-white rounded-md hover:bg-gray-100">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        fill="currentColor"
        className="svg-busca"
      >
        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
      </svg>
    </div>
  );
};

export default CampoBusca;
